import ChangePasswordPublic from "../components/public/changePasswordPublic";
import ForgotPassword from "../components/public/forgotPassword";
import Login from "../components/public/login";
import PasswordConfirmation from "../components/public/passwordConfirmation";
import PrivacyPolicy from "../components/public/privacyPolicy";
import TermsAndConditions from "../components/public/termsAndConditions";
import VerifyLogin from "../components/public/verifyMFA";

const publicRoutes = [
	{ path: "/login", element: <Login />, exact: true },
	{ path: "/forgotPassword", element: <ForgotPassword /> },
	{ path: "/changePassword", element: <ChangePasswordPublic /> },
	{ path: "/confirmation", element: <PasswordConfirmation /> },
	{ path: "/terms-and-conditions", element: <TermsAndConditions /> },
	{ path: "/privacy-policy", element: <PrivacyPolicy /> },
	{ path: "/verify-login", element: <VerifyLogin /> },
];

export default publicRoutes;
